var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "floatDrag",
      staticClass: "float-position",
      style: { left: _vm.left + "px", top: _vm.top + "px", zIndex: _vm.zIndex },
      on: {
        touchmove: function($event) {
          $event.preventDefault()
        },
        mousemove: function($event) {
          $event.preventDefault()
        },
        mousedown: _vm.mouseDown,
        mouseup: _vm.mouseUp
      }
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d75a38f8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d75a38f8","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/draggable.vue
// module id = 9
// module chunks = 0